import styled from 'styled-components'

/**
 * Styled components are used in order to style Price component. Props are passed through ThemeProvider.
 */
export const PriceStyle = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.color || props.theme.colors?.primary};
  font-size: ${(props) =>
    props.theme.priceFontSize || props.theme.fontSize || 1.2}rem;
  font-family: ${(props) => props.theme.fontFamily};
  margin: 0em 0em 0.5em 0em;
  del {
    color: red;
  }
`
